import { setBooleanFeatureFlagResolver } from '@atlaskit/platform-feature-flags';

import { getContentAPI } from '@canvas/frame-api/host-api/host-frame-context';

import { isFeatureFlagEnabled } from './client-feature-flags.ts';

export const setPlatformFlagResolver = () => {
  setBooleanFeatureFlagResolver((key) => {
    // Editor Core 221.7+ applies `container-type: inline-size` to chromeless
    // editors when this flag is enabled. Canvas positions and sizes its
    // chromeless editor inside a DOM overlay, and inline-size containment
    // causes the editor content to be measured independently of that overlay.
    // TODO(CNS-34574): This override only masks the breaking layout change; if
    // Editor removes/flips this flag on a future upgrade it will break silently
    // with no opt-out. Replace with a durable overlay-layout fix or a supported
    // Editor opt-out. https://product-fabric.atlassian.net/browse/CNS-34574
    if (key === 'platform_comment_container_query') {
      return false;
    }

    // If the platform packages are checking for visual refresh flags, we
    // default them to values provided either by our own statsig client or
    // our overrides in the url (?df=)
    if (key === 'platform-component-visual-refresh') {
      return isFeatureFlagEnabled('visualRefreshComponentsAndColors');
    }

    if (key === 'platform-visual-refresh-icons') {
      return isFeatureFlagEnabled('visualRefreshIcons');
    }

    if (key === 'platform_editor_reactions_picker_fix') {
      // If we're running in localdev, we need to return true for this flag
      // because the bridge API is not available in localdev
      if (!getContentAPI()?.platformFeatureFlagResolver?.(key)) {
        return true;
      }
    }

    // Smart Link feature flags -
    // We need both of these flags to be true for the smart link preview action size and hidden blanket in t
    // versions of smart card above v40.4.0 without the patch.
    if (key === 'platform_linking_enable_card_preview_action_size') {
      return isFeatureFlagEnabled('platform_linking_enable_card_preview_action_size');
    }

    if (key === 'linking_platform_hide_preview_action_blanket_prop') {
      return isFeatureFlagEnabled('linking_platform_hide_preview_action_blanket_prop');
    }

    // The below platform flags don't specifically target `canvas_web`, meaning
    // we can only see those visual changes on hello/pug -> thus turning it on
    // for local development purposes

    // Visual updates to smart link components
    if (key === 'platform-linking-visual-refresh-v1') {
      return true;
    }

    // Visual updates to Textfield component
    if (key === 'platform_design_system_team_safari_input_fix') {
      return true;
    }

    return getContentAPI()?.platformFeatureFlagResolver?.(key) || false;
  });
};
